import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { useFilePicker,  } from 'use-file-picker';
import {  FileContent } from 'use-file-picker/types';
import { Button } from '../Button';
import * as S from './styles';
import { Either } from '../../utils/propsUtil';
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { Icon } from '@iconify/react';
import { useTheme } from '../../utils/context/themeContext';
import { FileType } from '../../types/fileSelector/fileSelectorTypes';


export interface Props0<T extends HTMLElement = HTMLElement> extends React.HTMLAttributes<T> {
  accept: FileType[];
  multiple: boolean,
  setFile?: Dispatch<SetStateAction<FileContent<string> | undefined>>
  setFiles?: Dispatch<SetStateAction<FileContent<string>[] | undefined>>
  form?:boolean
  name?:string
  overlay?:boolean
}

export interface Props1 {
  title:string
}

export interface Props2 {
  children?: React.ReactNode;
}

export type FileSelectorProps = Props0 & Either<Props1, Props2>;


export function FileSelector (props: FileSelectorProps) {
  const { t } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { theme } = useTheme();

  const { openFilePicker, filesContent, loading} = useFilePicker({
    accept: props.accept,
    multiple: props.multiple,
    readAs: 'DataURL',

    onFilesRejected: ({ errors }) => {
      toast("Falha ao carregar arquivo", {type: 'error'});
      errors.forEach(e => {
        toast(e.name, {type: 'warning'});
      });
    },

    onFilesSuccessfullySelected: ({ plainFiles }) => {
      if (plainFiles.length > 0 && props.form && fileInputRef.current) {
        if (fileInputRef.current) {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(plainFiles[0]);
            fileInputRef.current.files = dataTransfer.files;
        }
    }
    },
  });

  useEffect(() => {
    if(filesContent == null || filesContent.length == 0) {return}
    props.setFile && props.setFile(filesContent[0])
    props.setFiles && props.setFiles(filesContent)
  },[filesContent])

  useEffect(() => {
    if(loading){
      toast(t("Carregando"), {type: 'info'});
    }
    },[loading])

  function handleButton()  {
    openFilePicker();
  }

  function handleWrapperClick()  {
    props.children && handleButton()
  }

  return (
    <S.FileWrapper loading={loading} onClick={handleWrapperClick}>
      { props.children ?
        props.children:
        <Button type='button' size='lg' iconName='ic:baseline-file-upload' onClick={handleButton} iconPosition='right'>{props.title}</Button>
      }

      {props.form &&
         <input type="file" name={props.name} ref={fileInputRef} style={{ display: "none" }} />
      }

      {props.overlay && <S.FileWrapperOverLay>
        <Icon icon="ic:baseline-file-upload" height={"100%"} color={theme.colors.background} />
      </S.FileWrapperOverLay>}
    </S.FileWrapper>
  )
}